import { Box, Link, Typography } from '@mui/material'
import { type ReactNode } from 'react'
import startWordmark from '../../../../assets/startWordmark.png'
import { SUPPORT_URL } from '../../../../constants/supportLinks'
import { styles } from './P2PAuthShell.styles'

// These pages render without the app footer, so its Support link is repeated under the card.
export const P2PAuthShell = ({ children }: { children: ReactNode }): JSX.Element => (
  <Box data-testid='p2pAuthShell' sx={styles.page}>
    <Box sx={styles.brandPanel}>
      <Box component='img' src={startWordmark} alt='START' data-testid='p2pAuthWordmark' sx={styles.logo} />
      <Box sx={styles.brandText}>
        <Typography variant='h3' sx={styles.brandHeading}>Peer to Peer Data Collection Request</Typography>
        <Typography variant='body1' sx={styles.brandCopy}>
          START gathers Peer to Peer data each school year to better understand Peer to Peer implementation across
          Michigan. Your responses help us plan for future Peer to Peer training and support, communicate key information
          about Peer to Peer with the Michigan Department of Education, and much more.
        </Typography>
        <Typography variant='body1' sx={styles.brandCopy}>
          Thank you for sharing your Peer to Peer data with us!
        </Typography>
      </Box>
    </Box>

    <Box sx={styles.formPanel}>
      <Box sx={styles.formCard}>{children}</Box>
      <Typography variant='caption' sx={styles.support}>
        Need help?{' '}
        <Link href={SUPPORT_URL} target='_blank' rel='noopener noreferrer' data-testid='p2pAuthSupport'>
          Contact Support
        </Link>
      </Typography>
    </Box>
  </Box>
)
